import { render, staticRenderFns } from "./recuperar-senha.vue?vue&type=template&id=6126b49e&"
import script from "./recuperar-senha.vue?vue&type=script&lang=js&"
export * from "./recuperar-senha.vue?vue&type=script&lang=js&"
import style0 from "./recuperar-senha.vue?vue&type=style&index=0&id=6126b49e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports